<template>
    <v-layout row wrap>
       <div class="upper-container">
            <div class="main_inner_container">
                <BackButton :page_name="back_button"></BackButton>
                <!-- /{{ payment_type }} -->
                <v-container>
                    <v-layout align-center justify-center row class="amount_container">
                        <v-flex xs12 sm12 md8 lg12 xl12 text-xs-center>
                            <!-- /{{this.payment_type}} -->
                            <div class="white-f" id="premium_data">${{premium_data}}<span id="payment_type"></span></div>
                            <div class="white-f">
                                <IconBase>
                                    <IconStarCheck  />
                                </IconBase>
                                Includes FDCA membership
                            </div>
                            <div class="table-container">
                                <div class="dtable">
                                    <div class="drow toggle_drow">
                                        <div class="dcell">
                                            <a v-on:click="ToggleSelected('yearly')">
                                                <div class="choice default" id="choice1"></div>
                                            </a>
                                        </div>
                                        <div class="dcell">
                                            <a v-on:click="ToggleSelected('monthly')">
                                                <div class="choice" id="choice2"></div>
                                            </a>
                                        </div>
                                        <div class="dcell">
                                            <a v-on:click="ToggleSelected('fortnightly')">
                                                <div class="choice" id="choice3"></div>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="drow toggle_drow">
                                        <div class="dcell"><a v-on:click="ToggleSelected('yearly')">YEARLY</a></div>
                                        <div class="dcell"><a v-on:click="ToggleSelected('monthly')">MONTHLY</a></div>
                                        <div class="dcell"><a v-on:click="ToggleSelected('fortnightly')"><span id="toggle_fortnight">FORTNIGHTLY</span></a></div>
                                    </div>
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </div>
        </div>
        <div></div>

        <transition name="fade">
            <div class="middle-container" id="middle-container" >
                <v-container>
                    <v-layout align-center justify-center row class="mod_middle_container">
                        <v-flex xs12 sm12 md12 lg12 xl12 text-xs-center>
                            <div class="dtable-con toggle_content_con">
                                <div class="dtable">
                                    <div class="drow">
                                        <div class="dcell elantis" v-if="this.payment_type == 'year'"><img src="../../assets/Visa.svg" width="30"></div>
                                        <div class="dcell elantis" v-if="this.payment_type == 'year'"><img src="../../assets/Mastercard.svg" width="30"></div>
                                        <div class="dcell elantis" v-if="this.payment_type != 'year'"><img src="../../assets/Elantis.jpg" width="30"></div>
                                        <div class="dcell breakdown">{{ breakdown }}</div>
                                    </div>
                                    
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </div>
            


            <!-- <div v-if="this.payment_type != 'year'">
                <v-container class="amount_expansion__container">
                    <v-layout align-center justify-center row class="amount_expansion">
                        <v-flex xs12 sm12 md12 lg12 xl12 text-xs-center>
                            <v-expansion-panel>
                                <v-expansion-panel-content>
                                    <template v-slot:header>
                                        <div>
                                            <span class="expansion_header">UPFRONT + {{ payment_type }}ly PAYMENTS</span>
                                            <br/>
                                            Total amount payable: {{ total_amount }}
                                        </div>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <div class="dtable-con toggle_content_con">
                                                <div class="dtable">
                                                    <div class="drow">
                                                        <div class="dcell elantis"><img src="../../assets/Visa.svg" width="30"></div>
                                                        <div class="dcell elantis"><img src="../../assets/Mastercard.svg" width="30"></div>
                                                        <div class="dcell breakdown">{{ breakdown }}</div>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                            <div class="dtable-con toggle_content_con">
                                                <div class="dtable">
                                                    <div class="drow">
                                                        <div class="dcell elantis"><img src="../../assets/Elantis.jpg" width="30"></div>
                                                        <div class="dcell breakdown">{{ breakdown }}</div>
                                                    </div>
                                                    
                                                </div>
                                            </div>


                                        </v-card-text>
                                    </v-card>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-flex>
                    </v-layout>
                </v-container>
            </div> -->
        </transition>

        <div class="error-container center" v-if="this.declarations == true">
            <v-container>
                <v-layout align-center justify-center row class="mod_middle_container">
                    <v-flex xs12 sm12 md12 lg7 xl8 text-xs-center>
                        Unfortunately we are unable to process your policy online since we require more information about your claims history. Please call out team on <span class="bold">1800 658 699</span> to proceed, quoting tour reference number <span class="bold"> {{ this.$parent.$parent.EducatorInsuranceProcess.quote_ref_num }}</span>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>

       
    </v-layout>
</template>

<script>
// class="educator-route-nav educator-package-nav no_progress_bar"
import IconBase from '@/components/IconBase.vue'
import BackButton from '@/components/BackButton.vue'
import IconArrowRight from '@/components/icons/arrowForward.vue'
import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconStarCheck from '@/components/icons/starCheck.vue'
import Dinero from 'dinero.js'
import json_data from '../../data.json'
//import PremiumComputation from '@/components/forms/PremiumComputation.vue'


export default {
    name: "PremiumToggle",
    components: {
        IconBase,
        IconArrowRight,
        IconArrowBack,
        IconStarCheck,
        BackButton
        //PremiumComputation
    },
    props:['backbutton'],
    data() {
        return {
            premium_data: 0,
            payment_type: 'year',
            yearly_data: 909,
            is_uw_gst: '',
            small_business_nsw: '',
            state_name: '',
            datas: json_data,
            total_amount: 0,
            declarations: '',
            back_button: this.backbutton,
            total_stamp_duty : 0,
            process: "",
            payable_amount:"", //total payable amount if monthly or fortnight
        }
    },
    mounted(){
    },
    methods: {
        ToggleSelected(params) {
            this.StartStepByStep();
            this.payable_amount = 0;
            this.$parent.$parent.EducatorInsuranceProcess.breakdown.interest = 0;
            this.process = this.$parent.$parent.ReturnProcess();
            this.$parent.$parent.RemoveClassFrom('choice', 'default');
            this.$parent.$parent[this.process].breakdown.payment_type = params;
            if (params == 'yearly') {
                this.premium_data = this.yearly_data.toFixed(2);
                this.payment_type = 'year';
                this.breakdown = 'Total amount payable: $' +  this.yearly_data.toFixed(2);
                this.payable_amount = this.yearly_data;
                document.getElementById('choice1').classList.add("default");
            } else if (params == 'monthly') {
                this.premium_data = this.ComputePaymentPlan('monthly', this.yearly_data).toFixed(2);
                this.payment_type = 'month';
                document.getElementById('choice2').classList.add("default");
            } else {
                this.premium_data = this.ComputePaymentPlan('fortnight', this.yearly_data).toFixed(2);
                this.payment_type = 'fortnight';
                document.getElementById('choice3').classList.add("default");
            }
            this.$parent.$parent.EducatorInsuranceProcess.breakdown.total = parseFloat(this.payable_amount).toFixed(2);
            this.$emit('TriggerToggle', params);
        },
        StartStepByStep(){
            var package_id_session = this.$parent.$parent.EducatorInsuranceProcess.package_id;
            this.is_uw_gst = this.$parent.$parent.EducatorInsuranceProcess.registered_for_gst;
            this.small_business_nsw = this.$parent.$parent.EducatorInsuranceProcess.small_business_disclaimer;
            this.datas = json_data;
            this.state_name = (this.$parent.$parent.EducatorInsuranceProcess.Addresses[0].state).toLowerCase();

            var package_details = this.GetPackageDetailsByPackageId(package_id_session);
            var package_id = package_details.id;
            var package_parent_or_child = package_details.type;
            var base_premium_parent = this.GetBasePremium(package_id, package_parent_or_child);
            var state_code = this.GetState(this.state_name);
            var stamp_duty_percentage_parent = this.GetStampDuty(state_code, package_parent_or_child);
            var computed_stamp_duty_parent = this.GetComputedStampFee(base_premium_parent, stamp_duty_percentage_parent);
            var sub_total_parent = this.GetSubTotal(base_premium_parent, computed_stamp_duty_parent);


            var children_package_details = this.GetPersonalAccidentForChildren(package_id);
            var children_package_id = children_package_details.children_package_id;
            package_parent_or_child = 1;
            var base_premium_children = this.GetBasePremium(children_package_id, package_parent_or_child);
            var stamp_duty_percentage_children = this.GetStampDuty(state_code, package_parent_or_child);
            var computed_stamp_duty_children = this.GetComputedStampFee(base_premium_children, stamp_duty_percentage_children);
            var sub_total_children = this.GetSubTotal(base_premium_children, computed_stamp_duty_children);



            var membership_fee = this.GetMembershipFee(package_id);
            var total_amount = this.GetTotalAmount(sub_total_parent, sub_total_children, membership_fee);
            this.membership_fee = this.DineroPrecisionWrapper(membership_fee).toFixed(2);

            this.yearly_data = total_amount;
            this.premium_data =  this.yearly_data.toFixed(2);
            this.total_amount = total_amount.toFixed(2);

            var declarations_arr = [this.$parent.$parent.EducatorInsuranceProcess.previous_claims, this.$parent.$parent.EducatorInsuranceProcess.outstanding_claims,this.$parent.$parent.EducatorInsuranceProcess.previous_policies];
            this.declarations = this.CheckDeclarations(declarations_arr);

            this.$emit('declarations', this.declarations);
            //this.payment_type = 'year';
            this.breakdown = 'Total amount payable: $' +  this.yearly_data.toFixed(2);
            
            let parent_breakdown = {};
            parent_breakdown.base_premium = this.DineroPrecisionWrapper(base_premium_parent[0].base_premium).toFixed(2);
            parent_breakdown.uw_gst = this.DineroPrecisionWrapper(base_premium_parent[0].uw_gst).toFixed(2);
            parent_breakdown.fdca_fee = this.DineroPrecisionWrapper(base_premium_parent[0].fdca_fee).toFixed(2);
            parent_breakdown.fdca_gst = this.DineroPrecisionWrapper(base_premium_parent[0].fdca_gst).toFixed(2);
            parent_breakdown.stamp_duty = this.DineroPrecisionWrapper(computed_stamp_duty_parent).toFixed(2);
            parent_breakdown.sub_total = this.DineroPrecisionWrapper(sub_total_parent).toFixed(2);
            parent_breakdown.type = "parent";
            this.$parent.$parent.EducatorInsuranceProcess.breakdown.parent = parent_breakdown;
            

            let children_breakdown = {};
            children_breakdown.base_premium = this.DineroPrecisionWrapper(base_premium_children[0].base_premium).toFixed(2); 
            children_breakdown.uw_gst = this.DineroPrecisionWrapper(base_premium_children[0].uw_gst).toFixed(2); 
            children_breakdown.fdca_fee = this.DineroPrecisionWrapper(base_premium_children[0].fdca_fee).toFixed(2); 
            children_breakdown.fdca_gst = this.DineroPrecisionWrapper(base_premium_children[0].fdca_gst).toFixed(2); 
            children_breakdown.stamp_duty = this.DineroPrecisionWrapper(computed_stamp_duty_children).toFixed(2); 
            children_breakdown.pa_sub_total = this.DineroPrecisionWrapper(sub_total_children).toFixed(2); 
            this.$parent.$parent.EducatorInsuranceProcess.breakdown.child = children_breakdown;
            this.$parent.$parent.EducatorInsuranceProcess.breakdown.membership_fee = this.DineroPrecisionWrapper(membership_fee).toFixed(2); 
            
            
            let total_stamp_duty = Dinero({
                amount: computed_stamp_duty_parent
            }).add(Dinero({
                amount: computed_stamp_duty_children
            })).getAmount();

            this.$parent.$parent.EducatorInsuranceProcess.breakdown.total_stamp_duty = this.DineroPrecisionWrapper(total_stamp_duty).toFixed(2); 
   

            let total_gst = Dinero({
                amount: base_premium_children[0].fdca_gst
            }).add(Dinero({
                amount: base_premium_parent[0].fdca_gst
            })).getAmount();

            this.$parent.$parent.EducatorInsuranceProcess.breakdown.total_gst = this.DineroPrecisionWrapper(total_gst).toFixed(2);      

        },
        ComputePaymentPlan(payment_plan, total_amount) {
            var interest = 0.1;
            var new_total_payable = total_amount + (total_amount * interest);
            var monthly = new_total_payable / 12;
            var two_months = monthly * 2;
            var ten_months = monthly * 10;
            var payment_plan_months = this.GetMonths(payment_plan);
            var payment_plan_amount = (new_total_payable - two_months) / payment_plan_months;
            var payment_plan_amount_ = parseFloat(payment_plan_amount).toFixed(2);
            var convert_to_int = Dinero({
                amount: 10000
            }).multiply(payment_plan_amount_).toUnit();
            var total = Dinero({
                amount: convert_to_int,
                currency: 'AUD',
                precision: 2
            }).toUnit();
            this.UpdateBreakdown(total, monthly, two_months, new_total_payable, payment_plan);
            this.payable_amount = new_total_payable;
            this.$parent.$parent.EducatorInsuranceProcess.breakdown.interest = (parseFloat(total_amount * interest).toFixed(2)).toString();
            return total;
        },
        UpdateBreakdown(total, monthly, two_months, new_total_payable, payment_plan) {
            if (payment_plan == 'monthly') {
                this.breakdown = '2x monthly payments of $' + parseFloat(two_months).toFixed(2) + ' followed by 10x monthly payments of $' + parseFloat(total).toFixed(2) + '. Total amount payable: $' + parseFloat(new_total_payable).toFixed(2);
            } else {
                this.breakdown = '2x monthly payments of $' + parseFloat(two_months).toFixed(2) + ' followed by 22x forthnightly payments of $' + parseFloat(total).toFixed(2) + '. Total amount payable: $' + parseFloat(new_total_payable).toFixed(2);
            }
        },
        GetMonths(payment_plan) {
            if (payment_plan == 'fortnight') {
                return 20;
            } else {
                return 10;
            }
        },
        CheckGst(is_uw_gst, package_parent_or_child, base_premium_data_) {
            //uw gst is true remove GST amount
            if (is_uw_gst && (package_parent_or_child == 0)) {
                return 0;
            } else {
                var uw_gst = Dinero({ amount: base_premium_data_ }).percentage(10).getAmount();
                return this.DineroMoneyWrapper(uw_gst);
            }
        },
        GetPackageDetailsByPackageId(package_id) {
            var packages = this.datas.educators.packages.package;
            var find_by_package_id = (packages.filter(p => p.id == package_id));
            var package_id = find_by_package_id[0];
            return package_id;
        },
        GetState(state_name) {
            var state = this.datas.educators.packages.states;
            var state_data = (state.filter(s => s.state_name == state_name));
            var group_state = state_data[0].group_state;
            return group_state;
        },
        GetBasePremium(package_id, package_parent_or_child) {
            var base_premium_data_ = this.datas.educators.packages.base_premium;
            var find_base_premium_ = (base_premium_data_.filter(bp => bp.package_id.indexOf(package_id) >= 0));
            var _base_premium = find_base_premium_[0].base_premium;
            var update_uw_gst = this.CheckGst(this.is_uw_gst, package_parent_or_child, _base_premium);
            find_base_premium_[0]['uw_gst'] = update_uw_gst;
            return find_base_premium_;
        },
        GetComputedStampFee(base_premium_data, stamp_fee_percentage) {

            var base_premium = base_premium_data[0].base_premium;
            var uw_gst = base_premium_data[0].uw_gst;
            var base_premium_uw_gst = Dinero({
                amount: base_premium
            }).add(Dinero({
                amount: uw_gst
            })).getAmount();
            var base_premium_uw_gst_ = Dinero({
                amount: base_premium_uw_gst,
                currency: 'AUD',
                precision: 2
            }).toUnit();
            var total_stamp_fee = base_premium_uw_gst_ * stamp_fee_percentage;
            var total = Math.round(total_stamp_fee);
            return total;
        },

        GetStampDuty(group_state, package_parent_or_child) {
            if (this.state_name == 'nsw' && (this.small_business_nsw) && package_parent_or_child == 0) {
                return 0;
            }
            var stamp_data = this.datas.educators.packages.stamp;
            var find_stamp = (stamp_data.filter(function(st) {
                return st.parent_or_child_type == package_parent_or_child && st.group_state == group_state;
            }));
            var stamp_fee_data = find_stamp[0].stamp_fee;
            return stamp_fee_data;
        },
        DineroMoneyWrapper(number) {
            var two_decimals = Dinero({
                amount: number
            }).getAmount();
            return two_decimals;
        },
        DineroPrecisionWrapper(number) {
            return Dinero({
                amount: number,
                currency: 'AUD',
                precision: 2
            }).toUnit();
        },
        GetSubTotal(base_premium_parent, computed_stamp_duty_parent) {
            var base_premium = this.DineroMoneyWrapper(base_premium_parent[0].base_premium);
            var fdca_fee = this.DineroMoneyWrapper(base_premium_parent[0].fdca_fee);
            var fdca_gst = this.DineroMoneyWrapper(base_premium_parent[0].fdca_gst);
            var uw_gst = this.DineroMoneyWrapper(base_premium_parent[0].uw_gst);
            var stamp_fee = this.DineroMoneyWrapper(computed_stamp_duty_parent);
            var package_sub_total = Dinero({
                amount: base_premium
            }).add(Dinero({
                amount: fdca_fee
            })).add(Dinero({
                amount: fdca_gst
            })).add(Dinero({
                amount: uw_gst
            })).add(Dinero({
                amount: stamp_fee
            })).getAmount();
            return package_sub_total;
        },
        GetPersonalAccidentForChildren(package_id) {
            var pfac = this.datas.educators.packages.personal_accident_for_children;
            var find_pafc = (pfac.filter(p => p.package_id.indexOf(package_id) >= 0));
            var children_package_id = find_pafc[0];
            return children_package_id;
        },
        GetMembershipFee(package_id) {
            var membership_data = this.datas.educators.packages.membership;
            var membership_data_ = (membership_data.filter(md => md.package_id.indexOf(package_id) >= 0));
            var membership_fee = membership_data_[0].membership_fee;
            return membership_fee

        },
        GetTotalAmount(sub_total_parent, sub_total_children, membership_fee) {
            var sub_total_parent_ = this.DineroMoneyWrapper(sub_total_parent);
            var sub_total_children_ = this.DineroMoneyWrapper(sub_total_children);
            var membership_fee_ = this.DineroMoneyWrapper(membership_fee);
            var additional_cover_total_cost = 0;

            var total_amount = Dinero({
                amount: sub_total_parent_
            }).add(Dinero({
                amount: sub_total_children_
            })).add(Dinero({
                amount: membership_fee_
            })).add(Dinero({
                 amount: additional_cover_total_cost
            })).getAmount();

            // 
            var total_amount_ = Dinero({
                amount: total_amount,
                currency: 'AUD',
                precision: 2
            }).toUnit();

            return total_amount_; 
        },
        CheckDeclarations(declarations_arr) {
            var counter = 0;
            for (var i = 0; i < declarations_arr.length; i++) {
                if (declarations_arr[i] == true) {
                    counter++;
                }
            }

            if (counter > 0) {
                return true;
            } else {
                return false;
            }
        },
    }
}
</script>

<style lang="scss" scoped>
    .upper-container {
        background: #0072BC !important;
        width: 100%;
    }

    .upper-container div, .table-container div a {
        color: #fff
    }

    .main_inner_container {
        max-width: 1024px;
        margin-left: auto;
        margin-right: auto;
    }

    #premium_data {
        font-size: 50px;
        font-weight: 600;
        text-align: center;
        margin-bottom: 5px;
    }

    
    .table-container {
        width: fit-content;
        display: block;
        margin-left: auto;
        margin-right: auto;
        margin-top: 15px;
    }

    .choice {
        width: 120px;
        height: 8px;
        background: #2080BF;
        display: inline-block
    }

    #choice1 {
        border-bottom-left-radius: 25px;
        border-top-left-radius: 25px
    }

    #choice3 {
        border-bottom-right-radius: 25px;
        border-top-right-radius: 25px
    }

    .dtable {
        display: table;
    }

    .drow {
        display: table-row;
    }

    .dcell {
        display: table-cell;
    }

    .default {
        background: #fff;
        border-radius: 25px;
        transition-timing-function: ease-out;
    }

    @media screen and (min-width: 0px) and (max-width: 470px) {
        #choice1,
        #choice2 {
            width: calc(80px + 2 * ((100vw - 320px) / 680));
        }
        #choice3 {
            width: calc(120px + 2 * ((100vw - 320px) / 680));
        }
    }
    .back-container {
        padding-top: 40px;
    }

    .back-container a {
        color: #fff;
        float: left;
    }

    #payment_type {
        font-size: 16px;
    }

    @media screen and (max-width: 1263px) and (min-width: 0px) {
        .main_inner_container {
            margin-left: 5%;
            margin-right: 5%;
        }
    }

    .error-container {
        background-color: #FEEAEA;
        padding: 20px;
        color: #D93B20;
        border: 1px solid #D93B20;
        width: 100%;
    }

    .center {
        text-align: center
    }

    .bold {
        font-weight: bold
    }

    .middle-container{
        background: #fff;
        width: 100%;
    }

    .middle-container .container{
        text-align: center
    }

    .toggle_content_con .dtable{
        margin: 0 auto;
    }

    .dcell.elantis img{
        margin-right: 10px;
        vertical-align: middle;
    }

    .dcell.elantis:nth-child(2) img{
        margin-right: 20px;
    }


   

    





</style>
